function importAll(r) {
  return r.keys().map(r);
}

const allMedia = importAll(require.context('./media/intro', true, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));

export const intro = {
    title: 'Springtime Saffron Pasta',
    description: 'Pasta with peas and asparagus, in a saffron cream sauce, topped with lemon zest, parmesan, and herbs',
    info: 'Total time: 1 hour, 15 minutes • Vegetarian',
    prepTime: 10,
    cookTime: 65,
    totalTime: 75,
    media: allMedia,
    storySummary: `This recipe is all about springtime flavors. It was adapated from a <a href="" target="_blank">Green's Cookbook</a> recipe. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
    storyMore: `<p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>`,
    keywords: ['pasta', 'spring', 'springtime', 'vegetarian', 'cream sauce', 'saffron', 'asparagus', 'lemon zest'],
    recipeCategory: ['dinner'],
    cuisine: 'Italian American',
    id: 'springtime-saffron-pasta',
    author: 'Restaurant name'
}